module.exports = __webpack_public_path__ + "img/card.fdb5cfc5.png";